import { observer } from 'mobx-react-lite';

import { Button, Hero } from '@cfm-media/pwa-ui-components';
import { LoadableStatus } from '../mobx-utils';
import { parseHtml } from '../core/utils';
import { useStore } from '../core/store';
import { useTranslation } from '../core/utils/translations';

import { ContentWrapper } from '../components/content-wrapper';
import { ErrorPage } from '../components/error-page';
import { Loader } from '../components/loader';
import { PageWrapper } from '../components/page-wrapper';
import { urls } from '../urls';

export const AirportParking = observer(() => {
  const { t } = useTranslation(['airport-parking', 'error-pages']);

  const booking = useStore().BookingStore.booking;

  if ([LoadableStatus.init, LoadableStatus.loading].includes(booking?.status)) {
    return <Loader />;
  }

  if ([LoadableStatus.error].includes(booking?.status)) {
    return (
      <PageWrapper>
        <ErrorPage
          body={t('error-pages:airport-parking-error-body-text')}
          buttonText={t('error-pages:airport-parking-error-back-button-text')}
          icon={'icon-warning'}
          link={urls.home}
          title={t('error-pages:airport-parking-error-title-text')}
        />
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Hero
        image="/public/assets/images/teasers/airport-parking.webp"
        className="!h-[250px] sm:!h-[400px]"
        headline={t('airport-parking:teaser-headline')}
      />

      <ContentWrapper>
        <div className="pwa-content">
          {parseHtml(t('airport-parking:main-content-text'))}

          <Button
            variant="primary"
            className="!w-full my-8"
            title={t(`airport-parking:cta-text`)}
            link={t(`airport-parking:cta-link`)}
            target="_blank"
          />
        </div>
      </ContentWrapper>
    </PageWrapper>
  );
});
